import { createContext, useContext, useState } from "react";

const ConfirmModalContext = createContext();

export const useConfirmModal = () => useContext(ConfirmModalContext);

export const ConfirmModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    open: false,
    message: "",
    onConfirm: null,
  });

  const showConfirm = ({ message, onConfirm }) => {
    setModal({
      open: true,
      message,
      onConfirm,
    });
  };

  const handleClose = () => {
    setModal({ open: false, message: "", onConfirm: null });
  };

  const handleConfirm = () => {
    modal.onConfirm?.();
    handleClose();
  };

  return (
    <ConfirmModalContext.Provider value={{ showConfirm }}>
      {children}
  
      {modal.open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 30, 60, 0.45)",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            animation: "inf-fadeIn 0.2s ease",
          }}
        >
          <style>{`
            @import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;600;700&display=swap');
  
            @keyframes inf-fadeIn {
              from { opacity: 0; }
              to   { opacity: 1; }
            }
            @keyframes inf-slideUp {
              from { opacity: 0; transform: translateY(12px) scale(0.98); }
              to   { opacity: 1; transform: translateY(0)   scale(1);    }
            }
  
            .inf-modal-cancel {
              flex: 1;
              padding: 10px 16px;
              border-radius: 8px;
              border: 1.5px solid #d1d9e6;
              background: #fff;
              color: #4a5568;
              font-family: 'Nunito Sans', sans-serif;
              font-size: 13.5px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.15s ease;
              letter-spacing: 0.01em;
            }
            .inf-modal-cancel:hover {
              background: #f4f6fb;
              border-color: #b0bdd0;
              color: #1a2540;
            }
  
            .inf-modal-confirm {
              flex: 1;
              padding: 10px 16px;
              border-radius: 8px;
              border: none;
              background: #D67A1F;
              color: #fff;
              font-family: 'Nunito Sans', sans-serif;
              font-size: 13.5px;
              font-weight: 700;
              cursor: pointer;
              transition: all 0.15s ease;
              letter-spacing: 0.02em;
              box-shadow: 0 4px 14px rgba(238, 75, 43, 0.3);
            }
            .inf-modal-confirm:hover {
              background:rgb(249, 143, 37);
              box-shadow: 0 6px 20px rgba(238, 75, 43, 0.42);
              transform: translateY(-1px);
            }
            .inf-modal-confirm:active {
              transform: translateY(0);
              box-shadow: 0 2px 8px rgba(238, 75, 43, 0.25);
            }
          `}</style>
  
          <div
            style={{
              background: "#ffffff",
              padding: "32px 28px 26px",
              borderRadius: "14px",
              width: "360px",
              maxWidth: "92%",
              boxShadow: "0 20px 60px rgba(10, 25, 60, 0.18), 0 2px 8px rgba(10,25,60,0.08)",
              border: "1px solid rgba(209, 217, 230, 0.8)",
              textAlign: "center",
              animation: "inf-slideUp 0.22s cubic-bezier(0.34, 1.4, 0.64, 1)",
              fontFamily: "'Nunito Sans', sans-serif",
            }}
          >
           
  
            {/* Title */}
            <p
              style={{
                fontSize: "15px",
                fontWeight: "700",
                color: "#1a2540",
                margin: "0 0 8px",
                letterSpacing: "-0.01em",
              }}
            >
              Confirm Action
            </p>
  
            {/* Message */}
            <p
              style={{
                fontSize: "13.5px",
                lineHeight: "1.65",
                color: "#667085",
                fontWeight: "400",
                margin: "0 0 26px",
              }}
            >
              {modal.message}
            </p>
  
          
            {/* Buttons */}
            <div style={{ display: "flex", gap: "10px" }}>
              <button className="inf-modal-cancel" onClick={handleClose}>
                Cancel
              </button>
              <button className="inf-modal-confirm" onClick={handleConfirm}>
                Yes, Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmModalContext.Provider>
  );
};